import { render } from "./BargainPrice.vue?vue&type=template&id=ff8dd3c0&scoped=true&ts=true&lang=pug"
import script from "./BargainPrice.vue?vue&type=script&lang=ts"
export * from "./BargainPrice.vue?vue&type=script&lang=ts"

import "./BargainPrice.vue?vue&type=style&index=0&id=ff8dd3c0&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8dd3c0"]])

export default __exports__